import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputField } from '@shared/ui/input-field';
import { Button } from '@shared/ui/button';
import AuthLayout from '@shared/ui/access-layout';
import ReactInputMask from 'react-input-mask';
import { useAppDispatch } from '../../../app/store/store';
import {
  setErrorNotification,
  setNotification,
} from '../../../app/store/notifications';
import { apiClient } from '../../../api/instance';
import { requestAccessSchema } from '../lib/request-access-schema';

interface RequestAccessFormData {
  first_name: string;
  last_name: string;
  patronymic: string;
  company_name: string;
  phonemy: string;
  email: string;
}

const RequestAccess = () => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<RequestAccessFormData>({
    mode: 'onChange',
    resolver: yupResolver(requestAccessSchema),
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    document.title = 'Получить доступ';
  }, []);

  const [isSubmit, setIsSubmit] = useState(false);

  const onSubmit = (data: RequestAccessFormData) => {
    apiClient
      .post('/companies/request_registration/', { ...data, phone: data.phonemy })
      .then(() => {
        dispatch(setNotification('Заявка успешна оставлена!'));
        setIsSubmit(true);
      })
      .catch(() => {
        dispatch(
          setErrorNotification(
            'Произошла ошибка, попробуйте позже оставить заявку'
          )
        );
      });
  };

  return (
    <AuthLayout
      leftContent={
        <section className="flex justify-center items-center flex-col absolute top-[45%] left-[25%] -translate-x-1/2 -translate-y-[20%] text-center w-[346px]">
          <h2 className="text-[28px] text-white">Получить доступ</h2>
          <div className="my-[34px] mx-auto w-[113px] border border-white"></div>
          <div className="font-medium text-[22px] mt-[34px] leading-[140%] text-white">
            Заполните форму, чтобы оставить заявку на доступ
          </div>
        </section>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)} className="w-[70%] relative">
        {!isSubmit ? (
          <>
            <h2 className="font-bold text-[28px] text-[#141414]">Заявка на доступ</h2>
            <div className="mt-[45px] text-[#b4b4b4] text-base leading-[140%]">
              Пожалуйста, введите информацию в поля ниже, чтобы оставить заявку
            </div>
            <div className="mt-[30px]">
              <InputField name="first_name" inputName="first_name" id="first_name" label="Имя" placeholder="Введите ваше имя" register={register} errors={errors} />
            </div>
            <div className="mt-[30px]">
              <InputField name="last_name" inputName="last_name" id="last_name" label="Фамилия" placeholder="Введите вашу фамилию" register={register} errors={errors} />
            </div>
            <div className="mt-[30px]">
              <InputField name="patronymic" inputName="patronymic" id="patronymic" label="Отчество" placeholder="Введите ваше отчество" register={register} errors={errors} />
            </div>
            <div className="mt-[30px]">
              <InputField name="company_name" inputName="company_name" id="company_name" label="Название компании" placeholder="Введите название компании" register={register} errors={errors} />
            </div>
            <div className="mt-[30px]">
              <Controller
                name="phonemy"
                control={control}
                render={({ field }) => (
                  <InputField
                    {...field}
                    as={ReactInputMask}
                    mask="+7 (***) ***-**-**"
                    id="phonemy"
                    name="phonemy"
                    label="Телефон"
                    errors={errors}
                  />
                )}
              />
            </div>
            <div className="mt-[30px]">
              <InputField name="email" inputName="email" id="email" label="Email адрес" placeholder="Введите ваш email" register={register} errors={errors} />
            </div>
            <Button type="submit">Отправить заявку</Button>
            <div className="mt-[45px] text-[#b4b4b4] text-base leading-[140%]">
              Уже зарегистрированы?{' '}
              <Link to="/login" style={{ cursor: 'pointer', color: 'blue' }}>
                Войти
              </Link>
            </div>
          </>
        ) : (
          <div className="mt-[45px] text-[#b4b4b4] text-base leading-[140%]">
            Ваш запрос принят. В ближайшее время менеджер с Вами свяжется.{' '}
            {'  '}
            <Link to="/login" style={{ cursor: 'pointer', color: 'blue' }}>
              Страница входа
            </Link>
          </div>
        )}
      </form>
    </AuthLayout>
  );
};

export default RequestAccess;
